/**
 * Applique le décalage d'altitude d'un marqueur (bâtiment 3D, ADR-017) au marqueur MapLibre :
 * `mgl-marker` ne relit pas son `offset` après création. `null` (pas de bâtiment, ou plan en
 * contours) le ramène au sol.
 */
export function applyMarkerOffset(
  marker: { setOffset(offset: [number, number]): unknown } | null | undefined,
  offset: [number, number] | null
): void {
  marker?.setOffset(offset ?? [0, 0]);
}
